function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "currentColor",
  d: "M14.837 24.547c.728-.383 1.598-.383 2.326 0l6.093 3.203c.097.051.209.069.317.05.272-.047.455-.305.408-.577l-1.163-6.785c-.14-.81.13-1.638.719-2.212l4.929-4.805c.079-.077.13-.177.146-.286.04-.273-.15-.527-.423-.567l-6.812-.99c-.814-.118-1.518-.63-1.882-1.367l-3.047-6.173c-.048-.098-.128-.178-.227-.227-.247-.122-.547-.02-.67.227l-3.046 6.173c-.364.738-1.068 1.25-1.882 1.367l-6.812.99c-.109.016-.21.067-.286.146-.193.198-.189.514.01.707l4.928 4.805c.59.574.858 1.401.72 2.212l-1.164 6.785c-.019.108-.001.22.05.317.128.244.43.338.675.21l6.093-3.203z"
});

var SvgIconStarLine = function SvgIconStarLine(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconStarLine, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-star-line.3cdf1fca.svg";
export { ForwardRef as ReactComponent };